import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";
import { DateTime } from "luxon";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  ChartDataLabels
);

function Despesas10Dias({ dados = [] }) {

  const formatDate = (dateStr) =>  dateStr ? DateTime.fromISO(dateStr).plus({ hours: 3 }).toFormat("dd") : "";

  /* ================= MONTAR DADOS ================= */

  const dias = dados.map(d =>
    formatDate(d.date)
  );

  const valores = dados.map(d =>
    Number(d.total_expenses || 0)
  );

  const data = {
    labels: dias,
    datasets: [
      {
        label: "Despesas",
        data: valores,
        backgroundColor: "rgba(249, 115, 22, 0.85)",
        borderRadius: 8,
        borderSkipped: false
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,

    animation: {
      duration: 1200,
      easing: "easeOutQuart"
    },

    plugins: {

      legend: {
        display: false
      },

      tooltip: {
        callbacks: {
          label: function (context) {
            return context.raw.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL"
            });
          }
        }
      },

      datalabels: {
        anchor: "end",
        align: "end",
        offset: 4,
        color: "#374151",

        font: {
          weight: "600",
          size: 11
        },

        formatter: function (value) {

          if (value === 0) return "";

          return value.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL"
          });

        }
      }

    },

    scales: {

      x: {
        grid: {
          display: false
        }
      },

      y: {
        beginAtZero: true,
        grid: {
          color: "rgba(0,0,0,0.05)"
        },
        ticks: {
          display: false
        }
      }

    }

  };

  return (
    <div style={{ height: "280px" }}>
      <Bar data={data} options={options} />
    </div>
  );
}

export default Despesas10Dias;